










































































































































































































import { Component, Vue } from "vue-property-decorator";
import EmergenciesView from "@/Emma/EmergenciesView.vue";
import EmergencyView from "@/Emma/EmergencyView.vue";
import WarningStream from "@/Emma/WarningStream.vue";
import EventBus from "@/event-bus.ts";
import { authUser } from "@/auth/User.ts";
import moment from "moment";
import EmergencyPopup from "@/Emma/EmergencyPopup.vue";
import ChooseEmergencyPopup from "@/Emma/ChooseEmergencyPopup.vue";

@Component({
  components: {
    "emergencies-view": EmergenciesView,
    "emergency-view": EmergencyView,
    "warning-stream": WarningStream,
    "emergency-popup": EmergencyPopup,
    "choose-emergency-popup": ChooseEmergencyPopup
  },
  filters: {
    moment: function(timestamp: number) {
      return moment.unix(timestamp).format("DD/MM/YYYY HH:mm");
    }
  }
})
export default class Emma extends Vue {
  activeTab: string = "control_panel";
  openedEmergency: Array<any> = [];
  lightboxSrc: string = "";
  showLightBox: boolean = false;
  showPublicNotice: boolean = false;
  public_notice_name: string = "";
  public_notice_description: string = "";
  public_notice_warning_level: string = "";
  sendingNotice: boolean = false;
  errorMessage: string = "";
  notices: Array<any> = [];
  noticeActiveTab: string = "list";
  noticesLoading: boolean = false;
  cities: string[] = [];
  selected_city: string = "";
  loading: boolean = false;

  created() {
    if (this.cities.length === 0) {
      this.cities =
        "admin" in authUser.roles
          ? authUser.roles["admin"]
          : authUser.roles["coc"];
    }
    if (this.selected_city === "") {
      if (authUser.emmaCity) this.changeCity(authUser.emmaCity);
      else {
        this.changeCity(this.cities[0]);
      }
    }
  }

  changeCity(city: string) {
    if (city !== this.selected_city) {
      this.loading = true;
      authUser.emmaCity = city;
      if (this.selected_city != city && this.selected_city != "")
        EventBus.$emit("refresh-entire-route");
      this.selected_city = city;
      this.loading = false;
    }
  }

  get isAdmin() {
    return "admin" in authUser.roles;
  }

  beforeMount() {
    EventBus.$on("open-emergency", this.openEmergency);
    EventBus.$on("show-lightbox", (src: string) => {
      this.lightboxSrc = src;
      this.showLightBox = true;
    });
    EventBus.$on("show-emergency-popup", (message: any) => {
      const popup = this.$refs.emergencyPopup as EmergencyPopup;
      popup.message = message;
      popup.name = message.title;
      popup.description = message.body;
      popup.coordinates = [message.coordinates[1], message.coordinates[0]];
      popup.show();
      this.$nextTick(() => {
        (popup.$refs.map as any).refresh();
      });
    });
    EventBus.$on("choose-emergency-popup", (message: any) => {
      const popup = this.$refs.chooseEmergencyPopup as ChooseEmergencyPopup;
      popup.message = message;
      popup.show();
    });

    this.$http.get("/emma/admin/public_notices").then(resp => {
      this.notices = resp.data;
    });
  }

  async loadMoreNotices() {
    let resp = null;
    try {
      this.noticesLoading = true;
      const last_message = this.notices[this.notices.length - 1];
      const last_id = last_message["id"];
      resp = await this.$http.get("/emma/admin/public_notices", {
        params: { after: last_id }
      });
      resp.data.forEach((el: any) => (el.is_sent = el.user_id == authUser.id));
      this.notices.push(...resp.data);
    } catch (e) {
    } finally {
      if (resp && resp.data.length == 0) this.noticesLoading = true;
      else this.noticesLoading = false;
    }
  }
  createEmergency() {
    const popup = this.$refs.emergencyPopup as EmergencyPopup;
    popup.message = null;
    popup.show();
    this.$nextTick(() => {
      (popup.$refs.map as any).refresh();
    });
  }

  createPublicNotice() {
    this.public_notice_name = "";
    this.public_notice_description = "";
    this.public_notice_warning_level = "";
    this.errorMessage = "";
    this.showPublicNotice = true;
  }

  async sendPublicNotice() {
    const formRes = this.$el.querySelector("form");
    const form = formRes ? <HTMLFormElement>formRes[0] : null;

    if (form && !form.reportValidity()) return;
    var formData = new FormData();
    formData.append("title", this.public_notice_name);
    formData.append("description", this.public_notice_description);
    formData.append("warning_level", this.public_notice_warning_level);
    try {
      this.sendingNotice = true;
      const resp = await this.$http({
        method: "POST",
        url: "/emma/admin/public_notices",
        data: formData
      });
      this.showPublicNotice = false;
    } catch (e) {
      this.errorMessage = "Impossibile inviare il messaggio";
    } finally {
      this.sendingNotice = false;
    }
  }

  openEmergency(emergency: any, notify: boolean = false) {
    if (!this.openedEmergency.find(el => el.id == emergency.id))
      this.openedEmergency.push(emergency);
    if( notify )
      emergency.notification = true;
    this.activeTab = emergency.id.toString();
  }

  closeEmergency(index: number) {
    if (this.openedEmergency.length > 0) {
      this.openedEmergency.splice(index, 1);
      this.$nextTick(() => (this.activeTab = "control_panel"));
    }
  }
}
